import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HeroCampaigns } from '../components/homepage2/HeroCampaigns';
import { LeadGenerator } from '../components/homepage2/LeadGenerator';
import { ServiceShowcase } from '../components/homepage2/ServiceShowcase';
import { GuruStandard } from '../components/homepage2/GuruStandard';
import { HowBookingWorks } from '../components/homepage2/HowBookingWorks';
import '../styles/homepage2.css';
import '../styles/homepage2-app.css';

// Approved Gleam Guru Homepage 2.0 (locked design, see /memory/homepage2-source).
const SECTION_HASHES = ['#services', '#guru-standard', '#how-booking-works'];

const HomePage = () => {
  const { hash, key } = useLocation();
  useEffect(() => {
    if (!SECTION_HASHES.includes(hash)) return undefined;
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 250);
    return () => clearTimeout(t);
  }, [hash, key]);

  return (
  <div className="hp2" data-testid="homepage">
    <div className="hp2-masthead-spacer" aria-hidden="true" />
    <HeroCampaigns />
    <LeadGenerator />
    <ServiceShowcase />
    <GuruStandard />
    <HowBookingWorks />
  </div>
  );
};

export default HomePage;
